'use strict';

angular.module('licensure.services')
    .factory('UserInvestigators', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/UserInvestigators', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;